var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 47.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M30.08,0a4.42,4.42,0,0,1,4,2.17,5.68,5.68,0,0,1,.83,3V22.64a4.42,4.42,0,0,1-2.17,4,5.68,5.68,0,0,1-3,.83H7.62L0,34.93V5.17a5.68,5.68,0,0,1,.83-3A4.42,4.42,0,0,1,4.79,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M40.09,12.55h5a4.54,4.54,0,0,1,4,2.21A6,6,0,0,1,50,18v29.6l-7.37-7.7H19.83c-4.18,0-4.79-4.34-4.79-4.34V32.38H28.55a12.65,12.65,0,0,0,8.18-2.88A8.51,8.51,0,0,0,40,22.87C40,15.77,40.09,12.55,40.09,12.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.fd75912eb9ca41f7df2cb8d2c9b43591.svg";
export { ForwardRef as ReactComponent };